export default __webpack_public_path__ + "static/media/undraw_reviews_lp8w.8a62bebd.svg";